import React from 'react'

const Interview_Mock_Test_1B = () => {
  return (
    <div>
      <h1>Mock Test 2</h1>
    </div>
  )
}

export default Interview_Mock_Test_1B
